import { TableBody as Body } from '@mui/material';
import dayjs from 'dayjs';
import { CloseOutlined } from '@mui/icons-material';

import { HeaderProperties } from '../../../../shared/uiComponents/Table/tableProperties';
import { BillingProperties } from '../../../../redux/API/ClientAPIHelpers/billingProperties';
import { CustomTableRow, RowTableCell } from '../../../../shared/uiComponents/Table/tableHelpers';
import { ModifiedSessionDetails } from '../MBHReport/tableInfo';

export const NonBillableHeaders: HeaderProperties[] = [
	{ id: '1', name: 'Client Name', orderBy: 'client.fullName' },
	{ id: '2', name: 'Session Date', orderBy: 'sessionDate' },
	{ id: '3', name: 'Session Type' },
	{ id: '4', name: 'Provider' },
	{ id: '5', name: 'Modified' },
	{ id: '6', name: 'Submit Date', orderBy: 'reportSubmittedAt' },
	{ id: '7', name: 'Download Date', orderBy: 'reportExportedAt' },
	{ id: '8', name: 'ELC', orderBy: 'client.isElc' },
];

export const NonBillableTableBody = ({ data }: { data: BillingProperties[] }) => (
	<Body>
		{data.map((row, index) => (
			<CustomTableRow key={index}>
				<RowTableCell>{row.client ? row.client.fullName : '-'}</RowTableCell>
				<RowTableCell>{dayjs.utc(row.sessionDate).format('MM-DD-YYYY')}</RowTableCell>
				<RowTableCell>{row.sessionType.name}</RowTableCell>
				<RowTableCell>{row.user ? row.user.fullName : '-'}</RowTableCell>
				<RowTableCell>
					{row.sessionDateModifiedDetails ? (
						<ModifiedSessionDetails item={row.sessionDateModifiedDetails} />
					) : (
						<CloseOutlined />
					)}
				</RowTableCell>
				<RowTableCell>
					{row.reportSubmittedAt ? dayjs(row.reportSubmittedAt).format('MM-DD-YYYY') : '-'}
				</RowTableCell>
				<RowTableCell>
					{row.reportExportedAt ? dayjs(row.reportExportedAt).format('MM-DD-YYYY') : '-'}
				</RowTableCell>
				<RowTableCell>{row.client?.isElc ? 'Yes' : ''}</RowTableCell>
			</CustomTableRow>
		))}
	</Body>
);
